import { createApp } from "vue";
import { createBootstrap } from "bootstrap-vue-next";
import VueMultiselect from "vue-multiselect";
import TimetableApp from "./TimetableApp.vue";

$(document).ready(function () {
	// Only on the timetable page.
	if (!/\/course-management\/timetable$/.test(window.location.pathname)) {
		return;
	}

	const container = document.getElementById("timetable-app");
	if (!container) {
		return;
	}

	const apiUrl = container.dataset.apiUrl;
	if (!apiUrl) {
		console.error("Missing configuration for timetable app");
		return;
	}

	const app = createApp(TimetableApp, { apiUrl });
	app.use(createBootstrap());
	app.component("VMultiselect", VueMultiselect);
	app.mount(container);
});
